import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  search: {
    display: 'flex',
    alignItems: 'center',
    width: theme.spacing(50),
    maxWidth: '100%',
  },
  searchRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  columnAction: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginRight: theme.spacing(2),
  },
  sections: {
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(1),
    paddingBottom: theme.spacing(14),
  },
  recipientSource: {
    padding: theme.spacing(3),
    color: theme.palette.labraText.description,
  },
  loadError: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(3),
    color: theme.palette.labraText.description,
  },
  sectionHeader: {
    display: 'grid',
    gridTemplateColumns: `${theme.spacing(27)} 1fr`,
    padding: theme.spacing(2),
    color: theme.palette.labraText.description,
  },
  sectionRow: {
    display: 'grid',
    gridTemplateColumns: `${theme.spacing(27)} 1fr`,
    alignItems: 'center',
    minHeight: theme.spacing(8),
    padding: theme.spacing(2),
    '&:nth-of-type(even)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))
